import { Column } from 'app/design/primitives/box';
import { PCImage } from 'app/design/primitives/image';
import { Text } from 'app/design/primitives/text';
import { type FoundUser } from 'app/network/user';
import { getImageVariantUrl } from 'app/lib/image-variants';
import { Pressable, View } from 'react-native';
import { createTheme as createDSTheme } from 'app/shopify';
import { IconX } from '@tabler/icons-react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';

const theme = createDSTheme();

export const SelectedMemberBubble = function SelectedMemberBubble({
  user,
  onRemove,
}: {
  user: FoundUser;
  onRemove: (user: FoundUser) => void;
}) {
  const firstName = user.profile?.firstName ?? '';
  const handleRemove = () => onRemove(user);

  return (
    <Column alignItems="center" gap="spacing.general.x0,5" style={{ width: 64 }}>
      <View style={{ position: 'relative' }}>
        {user.profile?.picture ? (
          <PCImage
            aspectRatio={1}
            cachePolicy="memory-disk"
            height={50}
            recyclingKey={`${user.profile.picture}-group-bubble`}
            source={{ uri: getImageVariantUrl(user.profile.picture, 'mini') }}
            style={{ borderRadius: 25 }}
          />
        ) : (
          <View
            style={{
              width: 50,
              height: 50,
              borderRadius: 25,
              backgroundColor: theme.colors['surface.disabled'],
            }}
          />
        )}
        <Pressable
          hitSlop={8}
          onPress={handleRemove}
          style={{
            position: 'absolute',
            top: -4,
            right: -4,
            width: 20,
            height: 20,
            borderRadius: 10,
            backgroundColor: theme.colors['surface.inverse.tertiary-neutral'],
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <IconX strokeWidth={ICON_STROKE_WIDTH} size={10} color={theme.colors['icon.primary']} />
        </Pressable>
      </View>
      <Text fontSize={11} numberOfLines={1} textAlign="center" style={{ width: 64 }}>
        {firstName}
      </Text>
    </Column>
  );
};
